import { FormControl, FormGroup, Validators } from '@angular/forms';
import { uniqueValueValidator, Unsubscriber } from '@core';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalRef } from '@core-lib/modules/modal-container';
import { Store } from '@ngrx/store';
import { PreferenceService } from '@core-lib/services/preference.service';
import { Cheque, IBaseEmailForm, IEditPreferences, IPreference } from '@core-lib/models/preference.model';
import { Preference } from '@core-lib/enums/preference.enum';

@Component({
    selector: 'settings-cheque',
    templateUrl: './settings-cheque.component.html',
    styleUrls: ['./settings-cheque.component.scss'],
    standalone: false
})
export class SettingChequeComponent extends Unsubscriber implements OnInit, OnDestroy {
	@Input() preferencesCheques$: Observable<Cheque> = new Observable<Cheque>();
	@Input() structureId: string;
	@Input() allowEdit: boolean;

	modalRef: ModalRef;
	form: FormGroup;
	isEmail1Required = false;

	preferencesCheques: Cheque | null = null;
	anyEditMode$: Observable<boolean> = this.preferenceService.anyEditMode$;

	get isEditMode() {
		return this.preferenceService.chequeEditMode$.value;
	}

	constructor(
		public preferenceService: PreferenceService,
		protected store$: Store,
		private toastr: ToastrService,
		private translate: TranslateService
	) {
		super();
	}

	ngOnInit(): void {
		this.preferencesCheques$.subscribe(cheques => {
			this.preferencesCheques = cheques;
			this.initForm();
		});
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	private initForm(): void {
		this.preferenceService.chequeEditMode$.next(false);
		this.form = new FormGroup<IBaseEmailForm>({
			email1: new FormControl(this.preferencesCheques.email1.valeur, [
				Validators.email,
				Validators.required,
				uniqueValueValidator(['email2', 'email3'])
			]),
			email2: new FormControl(this.preferencesCheques.email2.valeur, [Validators.email, uniqueValueValidator(['email1', 'email3'])]),
			email3: new FormControl(this.preferencesCheques.email3.valeur, [Validators.email, uniqueValueValidator(['email1', 'email2'])])
		});
		this.updateEmailRequiredState();
	}

	private updateEmailRequiredState(): void {
		const email1Ctrl = this.form.get('email1') as FormControl;
		email1Ctrl.updateValueAndValidity();
	}

	edit(): void {
		this.preferenceService.chequeEditMode$.next(true);
	}

	cancel(): void {
		this.preferenceService.chequeEditMode$.next(false);
		this.initForm();
	}

	confirm(): void {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}
		var preferences = [
			<IPreference>{
				actif: true,
				code: Preference.cheques.email1.code,
				valeur: this.form.value.email1
			},
			<IPreference>{
				actif: true,
				code: Preference.cheques.email2.code,
				valeur: this.form.value.email2
			},
			<IPreference>{
				actif: true,
				code: Preference.cheques.email3.code,
				valeur: this.form.value.email3
			}
		];

		const editPreferences: IEditPreferences = {
			category: Preference.category.cheques,
			preferences: preferences
		};

		this.preferenceService.edit(this.structureId, editPreferences).subscribe({
			next: () => {
				this.translate.get('Success.Save').subscribe(msg => this.toastr.success(msg));
				this.preferenceService.notificationsEditMode$.next(false);
				this.preferenceService.get(this.structureId, true);
			},
			error: error => {
				this.toastr.error(error);
			}
		});
	}
}
